import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

import Typography from "@mui/material/Typography";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "#fff",
  fontFamily: '"Penna"',
  fontSize: "1.8rem",
  fontWeight: "bold",
}));

function Upload(props) {
  const [isUploading, setUploading] = React.useState(false);
  const [itemData, setItemData] = React.useState([]);

  const isLocalDev =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development";
  const baseUrl = isLocalDev ? "http://localhost:8000/" : "/";

  let urlImg = baseUrl + "getimg.php";

  React.useEffect(() => {
    fetch(urlImg)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setItemData(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [urlImg]);

  let url = baseUrl + "img_upload.php";

  const handleFile = async (event) => {
    setUploading(true);
    const f = event.target.files;
    let baseImgArray = itemData;

    for (let i = 0; i < f.length; i++) {
      const file = f[i];
      let formData = new FormData();
      formData.append("files", file, file.name);
      try {
        const r = await fetch(url, {
          method: "POST",
          body: formData,
        });
        const j = await r.json();
        if (j.code === 200) {
          const img = {
            img: j.path,
          };
          const newImg = [img].concat(baseImgArray);
          setItemData(newImg);
          baseImgArray = newImg;
        }
      } catch (e) {
        console.log(e);
      }

      //  .then((d) => d.json())
      //   .then((r) => {
      //
      //   })
      //   .catch(e => { console.log(e) })
    }
    setUploading(false);
  };

  return (
    <Container maxWidth="xl" sx={{ pt: "1em" }}>
      <Box sx={{ width: "100%" }}>
        <Item sx={{backgroundColor: "transparent", boxShadow: "unset"}}>
          <Typography
            variant="h5"
            color="text.secondary"
            sx={{
              paddingTop: "10px",
              paddingBottom: "10px",
              fontFamily: '"Penna"',
              fontSize: "1.8rem",
              fontWeight: "bold",
              color:"#fff"
            }}
          >
            Qua potrete caricare le foto e i video che farete durante la
            giornata e noi, una volta pronte, metteremo a nostra volta quelle
            del fotografo.
          </Typography>
        </Item>
        <Stack spacing={0}>
          <Item sx={{backgroundColor: "transparent"}}>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={
                !isUploading ? (
                  <CloudUploadIcon />
                ) : (
                  <CircularProgress color="secondary" />
                )
              }
              sx={{ marginBottom: "10px" }}
            >
              Upload file
              <VisuallyHiddenInput
                type="file"
                multiple
                onEnded={(e) => handleFile(e)}
                onChange={(e) => handleFile(e)}
              />
            </Button>

            <Box
              sx={{
                width: "100%",
                height: "90vh",
                overflowY: "scroll",
                paddingTop: "0px",
              }}
            >
              <ImageList variant="masonry" cols={3} gap={8}>
                {itemData.map((item) => (
                  <ImageListItem key={item.img}>
                    <img
                      srcSet={`${baseUrl}${item.img}`}
                      src={`${baseUrl}${item.img}`}
                      alt={item.title}
                      loading="lazy"
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Box>
          </Item>
        </Stack>
      </Box>
    </Container>
  );
}

export default Upload;
